import { useEffect, useState } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

import { usePdpPricingOptimizationVariant_item$key } from './__generated__/usePdpPricingOptimizationVariant_item.graphql';

const TEST_NAME = 'PDPPricingOptimization';

const itemFragment = graphql`
    fragment usePdpPricingOptimizationVariant_item on Item {
        isSold
        isUnpurchasable
    }
`;

export const usePdpPricingOptimizationVariant = (
    itemRef: usePdpPricingOptimizationVariant_item$key
): boolean | null => {
    const item = useFragment(itemFragment, itemRef);
    const isUnavailable = item.isSold || item.isUnpurchasable;

    const [isVariant, setIsVariant] = useState<boolean | null>(null);

    useEffect(() => {
        setIsVariant(getAbTestV2(TEST_NAME)?.variant === 'variant' && !isUnavailable);
    }, [isUnavailable]);

    return isVariant;
};

export const useTrackPdpPricingOptimization = (
    itemRef: usePdpPricingOptimizationVariant_item$key
): void => {
    const item = useFragment(itemFragment, itemRef);
    const isUnavailable = item.isSold || item.isUnpurchasable;

    useEffect(() => {
        if (!isUnavailable) {
            trackAbTestV2Variant(TEST_NAME);
        }
    }, [isUnavailable]);
};
